import Swal from "sweetalert2";

export default function alertDelete(): Promise<boolean> {
    return new Promise(resolve => {
        Swal.fire({
            icon: "warning",
            title: "Hapus data?",
            text: "data akan dihapus secara permanen"
        })
            .then(result => {
                resolve(result.isConfirmed)
            })
    })
}